// PRD §3.4 — DRAFT (gray) / PUBLISHED (green) status pill.
// Reused across the tree row and the item detail header (later slice).

import { useTranslation } from 'react-i18next';

import type { ProItemStatus } from '../types/pro-item-design.types';

export function ProStatusBadge({ status }: { status: ProItemStatus }) {
  const { t } = useTranslation('pro-item-design');
  const className =
    status === 'PUBLISHED' ? 'badge badge-success' : 'badge badge-gray';
  const label =
    status === 'PUBLISHED' ? t('status.published') : t('status.draft');
  return (
    <span className={className} style={{ fontSize: 11 }}>
      {label}
    </span>
  );
}
